import { render, staticRenderFns } from "./LandFeature.vue?vue&type=template&id=1f133bb0&scoped=true&"
import script from "./LandFeature.vue?vue&type=script&lang=js&"
export * from "./LandFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f133bb0",
  null
  
)

export default component.exports